import { render, staticRenderFns } from "./FieldNumber.vue?vue&type=template&id=dd9d1d70&scoped=true"
import script from "./FieldNumber.vue?vue&type=script&lang=js"
export * from "./FieldNumber.vue?vue&type=script&lang=js"
import style0 from "./FieldNumber.vue?vue&type=style&index=0&id=dd9d1d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9d1d70",
  null
  
)

export default component.exports